module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img.a5e65bf1.webp";